module.exports = __webpack_public_path__ + "static/TT2-evergreen-page-screening-sales-discover-iStock-1221739066.4af9c482.jpg";